module.exports = __webpack_public_path__ + "static/media/468x60_0003_ro.d07f1be0.png";